module.exports = __webpack_public_path__ + "static/wizard-school-f2a7ef3224443f428b86b8560e53d7e0.png";